import { inject, injectable } from 'tsyringe';
import { NoRecommendationsReasons } from '../no-recommendations-reasons.enums';
import { ConditionContext } from './interfaces/condition-context.interface';
import { ICondition, MatchResult } from './interfaces/condition.interface';
import {
  conditionType,
  ConditionType,
} from './decorators/condition-type.decorator';
import { LoggerService } from '../../logger.service';
import {
  kDITOWUtilsWrapper,
  kDITOWWrapper,
} from '../../../constants/injectionTokens';
import { IOWWrapper } from '../../../interfaces/ow-wrappers/ow-wrapper.interface';
import { IOWUtilsWrapper } from '../../../interfaces/ow-wrappers/ow-utils-wrapper.interface';
import { kPlatformMap } from '../../../constants/constants';

// -----------------------------------------------------------------------------
@injectable()
@conditionType(ConditionType.AppSpecific)
export class ConditionExtensionPhasing implements ICondition {
  private readonly logger = LoggerService.getCategory(
    'ConditionExtensionPhasing',
  );

  // ---------------------------------------------------------------------------
  public constructor(
    @inject(kDITOWWrapper)
    private readonly owWrapper: IOWWrapper,
    @inject(kDITOWUtilsWrapper)
    private readonly owUtilsWrapper: IOWUtilsWrapper,
  ) {}

  // ---------------------------------------------------------------------------
  // ICondition
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  public get id(): string {
    return this.logger.name;
  }

  // ---------------------------------------------------------------------------
  async match(context: ConditionContext): Promise<MatchResult> {
    const { application } = context;

    const platform = this.owWrapper.getPlatform();
    const extensionPhasing = application[kPlatformMap.get(platform)];

    const userPhasing = await this.owUtilsWrapper.getPersistentPhasedPercent();
    const match = userPhasing <= extensionPhasing;
    const reason = match ? null : NoRecommendationsReasons.ExtensionPhasing;

    return [match, reason];
  }
}
